import {httpGet} from "../libs/http";

export const loadDashboard = (onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/dashboard/', (res) => onSuccess(res), (err) => onFailure(err));
};
